import React from 'react';
import BrowserFrame from './BrowserFrame';

const EcommerceAdmin: React.FC = () => {
  const orders = [
    { id: '#10847', client: 'Karim B.', total: '€245', status: 'Payé', color: '#2E7D32' },
    { id: '#10846', client: 'Sarah L.', total: '€89', status: 'En cours', color: 'var(--gold-dark)' },
    { id: '#10845', client: 'Mehdi R.', total: '€412', status: 'Expédié', color: 'var(--blue)' },
    { id: '#10844', client: 'Lina K.', total: '€34', status: 'Payé', color: '#2E7D32' },
  ];

  const bars = [35, 48, 32, 62, 45, 72, 58];

  return (
    <BrowserFrame url="miid.app/shop/admin">
      <div style={{ padding: '1rem', background: 'var(--cream)', minHeight: '260px', fontFamily: "'Montserrat', sans-serif" }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '.9rem' }}>
          <div style={{ fontSize: '.72rem', fontWeight: 600, color: 'var(--ink)' }}>E-commerce + ERP</div>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: '.4rem', fontSize: '.5rem', color: 'var(--ink2)' }}>
            <span style={{ width: '5px', height: '5px', borderRadius: '50%', background: '#2E7D32' }} />
            Sync ERP active
          </div>
        </div>

        {/* KPIs + chart */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.2fr', gap: '.5rem', marginBottom: '.7rem' }}>
          {/* Stats */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '.4rem' }}>
            {[
              { label: 'CA du jour', value: '€8 420', trend: '+18%' },
              { label: 'Commandes', value: '47', trend: '+12%' },
            ].map((k) => (
              <div key={k.label} style={{ background: 'var(--white)', border: '1px solid var(--border)', padding: '.5rem .6rem', borderRadius: '4px' }}>
                <div style={{ fontSize: '.42rem', color: 'var(--ink2)', letterSpacing: '.08em', textTransform: 'uppercase' }}>{k.label}</div>
                <div style={{ fontSize: '.9rem', fontWeight: 700, color: 'var(--ink)', fontFamily: "'Cormorant Garamond', serif", lineHeight: 1 }}>{k.value}</div>
                <div style={{ fontSize: '.45rem', color: '#2E7D32', fontWeight: 600, marginTop: '.15rem' }}>▲ {k.trend}</div>
              </div>
            ))}
          </div>

          {/* Bar chart */}
          <div style={{ background: 'var(--white)', border: '1px solid var(--border)', padding: '.5rem .6rem', borderRadius: '4px' }}>
            <div style={{ fontSize: '.45rem', color: 'var(--ink2)', letterSpacing: '.08em', textTransform: 'uppercase', marginBottom: '.3rem' }}>Ventes 7j</div>
            <div style={{ display: 'flex', alignItems: 'end', gap: '4px', height: '60px' }}>
              {bars.map((h, i) => (
                <div
                  key={i}
                  style={{
                    flex: 1,
                    height: `${h}%`,
                    background: i === bars.length - 1 ? 'var(--gold)' : 'var(--blue)',
                    opacity: i === bars.length - 1 ? 1 : 0.3 + (h / 100),
                    borderRadius: '2px 2px 0 0',
                    transition: 'height .6s ease',
                  }}
                />
              ))}
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '.2rem', fontSize: '.38rem', color: 'var(--ink2)' }}>
              <span>L</span><span>M</span><span>M</span><span>J</span><span>V</span><span>S</span><span>D</span>
            </div>
          </div>
        </div>

        {/* Orders table */}
        <div style={{ background: 'var(--white)', border: '1px solid var(--border)', borderRadius: '4px', overflow: 'hidden' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.2fr .7fr .8fr', padding: '.35rem .6rem', background: 'var(--blue-pale)', fontSize: '.42rem', color: 'var(--ink2)', fontWeight: 600, letterSpacing: '.08em', textTransform: 'uppercase' }}>
            <span>ID</span><span>Client</span><span>Total</span><span>Statut</span>
          </div>
          {orders.map((o, i) => (
            <div key={o.id} style={{ display: 'grid', gridTemplateColumns: '1fr 1.2fr .7fr .8fr', padding: '.35rem .6rem', fontSize: '.52rem', color: 'var(--ink)', borderTop: i > 0 ? '1px solid var(--border)' : 'none', alignItems: 'center' }}>
              <span style={{ fontFamily: 'monospace', color: 'var(--blue)' }}>{o.id}</span>
              <span>{o.client}</span>
              <span style={{ fontWeight: 600 }}>{o.total}</span>
              <span style={{ fontSize: '.45rem', fontWeight: 700, color: o.color, letterSpacing: '.05em' }}>● {o.status}</span>
            </div>
          ))}
        </div>
      </div>
    </BrowserFrame>
  );
};

export default EcommerceAdmin;
